import React, { useState } from "react";
import DataTable from "components/DataTable";
import PageWrapperForm from "components/PageWrapperForm";
import { useTableDataWithPost } from "hooks/useTableWithPost";
import { PlanServiceChargeData } from "config/tableConfigs";
import PlanServiceChargeFormModal from "./components/PlanServiceChargeFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";

const PlanServiceChargePage = () => {
  const [modalShow, setModalShow]       = useState(false);
  const [modalMode, setModalMode]       = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh]           = useState(0);
  const { userid } = useSession();

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://api.mokshiq.in/plan_service_charge_action",
    PlanServiceChargeData,
    formdata,
    refresh
  );

  const handleAddUser  = () => { setModalMode("add"); setSelectedUser(null); setModalShow(true); };
  const handleEditUser = (user) => { setModalMode("edit"); setSelectedUser(user); setModalShow(true); };
  const handleDelete   = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const el = document.getElementById("deletePlanServiceCharge");
      if (el) window.bootstrap.Modal.getOrCreateInstance(el).show();
    }, 100);
  };

  return (
    <div>
      <PageWrapperForm config={PlanServiceChargeData} handleOnclick={handleAddUser} buttonTitle="Add Service Charge">
        <DataTable
          config={PlanServiceChargeData}
          tableData={tableData}
          onEdit={handleEditUser}
          onDelete={handleDelete}
        />
      </PageWrapperForm>

      <PlanServiceChargeFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={() => { setRefresh(p => p + 1); setModalShow(false); }}
      />

      <DeleteModal
        deleteid={selectedUser}
        id="deletePlanServiceCharge"
        title="Delete Service Charge"
        message="Are you sure you want to delete this service charge?"
        apiUrl="https://api.mokshiq.in/plan_service_charge_action"
        onSuccess={() => setRefresh(p => p + 1)}
      />
    </div>
  );
};

export default PlanServiceChargePage;